// Third-party imports
import $ from 'jquery';

// Module name
export const MODULE_NAME = 'checkbox';

export let global_vars = {};

export function initialize() {
    let cssVisibleClass = 'js-checkboxPopUp-visible';
    checkboxPopUpEventHandler(cssVisibleClass);
}

function checkboxPopUpEventHandler(cssVisibleClass) {
    $('.js-checkboxPopUp-checkbox').on('change', () => {
        let popUp = $(this)
            .closest('.js-checkboxPopUp-wrapper')
            .find('.js-checkboxPopUp-popUpWrapper');
        if (this.checked) {
            addPopUpClass(popUp, cssVisibleClass);
        } else {
            removePopUpClass(popUp, cssVisibleClass);
        }
        popUpClosingEventHandler(popUp, cssVisibleClass);
    });
}

function addPopUpClass(target, cssVisibleClass) {
    target.addClass(cssVisibleClass);
}

function removePopUpClass(target, cssVisibleClass) {
    target.removeClass(cssVisibleClass);
}

function popUpClosingEventHandler(popUp, cssVisibleClass) {
    $('.js-checkboxPopUp-closeButton').on('click', () => {
        removePopUpClass(popUp, cssVisibleClass);
    });
}
